import { map, uniq } from 'lodash-es'
import { isNonEmptyArray } from '#app/lib/boolean_tests'
import type { SerializedItemWithUserData } from '#inventory/lib/items'
import { I18n } from '#user/lib/i18n'
import { mainUser } from '#user/lib/main_user'

export function getCounterText (editionItems: SerializedItemWithUserData[]) {
  return I18n('users_count_have_this_book', { smart_count: getOwnersCountPerEdition(editionItems) })
}

export function getOwnersCountPerEdition (editionItems: SerializedItemWithUserData[]) {
  if (isNonEmptyArray(editionItems)) {
    const notMainUserEditions = editionItems.filter(notMainUserOwner)
    return uniq(map(notMainUserEditions, 'owner')).length
  }
}

const notMainUserOwner = (item: SerializedItemWithUserData) => item.owner !== mainUser?._id
